export default interface CardType<DATA> {
    type: CardTypes,
    data: DATA
}

export enum CardTypes {
    ad = 'ad',
    event = 'event'
}